import React from 'react';
import PropTypes from 'prop-types';
import config from '../../config';

const GiftHeader = ({ copy }) => {
  const { headerText, subHeaderText } = copy;
  const redeemUrl = window.location.origin + config.giftRedeemUrl;
  return (
    <div className="gift-purchase__header">
      <h1 className="gift-purchase-header__title">{headerText}</h1>
      <p>
        {subHeaderText}
      </p>
      <p>
        <a href={redeemUrl}> Have a gift card? Redeem here</a>
      </p>
    </div>
  );
};

GiftHeader.propTypes = {
  copy: PropTypes.shape({
    headerText: PropTypes.string,
    subHeaderText: PropTypes.string,
  }),
};

GiftHeader.defaultProps = {
  copy: null,
};

export default GiftHeader;
